<template>
  <div class="review">
    <el-input
      type="textarea"
      v-model="content"
      placeholder="说点什么..."
      :maxlength="200"
      :show-word-limit="true"
    ></el-input>
    <div class="controls">
      <el-upload
        class="image"
        name="files"
        :action="'http://foodsafety.yonghui.cn/api/resource/uploadFile'"
        :on-success="(resource) => { onUploadSuccess('contentImages', resource.data) }"
        :on-progress="onUploadProgress"
        :on-change="onUploadChange"
        :on-remove="(file) => { onUploadRemove('contentImages', file.name) }"
        :show-file-list="false"
        multiple
      >
        <div>
          <img src="@/assets/图片.png" v-if="theme === 'normal'" />
          <img src="/liquor/图片 copy.png" v-else />
          <div>图片</div>
        </div>
      </el-upload>
      <el-upload
        class="video"
        name="files"
        :action="'http://foodsafety.yonghui.cn/api/resource/uploadFile'"
        :on-success="(resource) => { onUploadSuccess('contentVideos', resource.data) }"
        :on-progress="onUploadProgress"
        :on-change="onUploadChange"
        :on-remove="(file) => { onUploadRemove('contentVideos', file.name) }"
        :show-file-list="false"
        multiple
      >
        <div>
          <img src="@/assets/视频.png" v-if="theme === 'normal'" />
          <img src="/liquor/视频 copy.png" v-else />
          <div>视频</div>
        </div>
      </el-upload>
      <el-popover placement="right" width="400" trigger="click">
        <CommodityMarketingDisccussReviewEmojiInput @select="onEmojiInput" />
        <div class="emoji" slot="reference">
          <img src="@/assets/表情.png" v-if="theme === 'normal'" />
          <img src="/liquor/表情 copy.png" v-else />
          <div>表情</div>
        </div>
      </el-popover>

      <div class="submit">
        <el-button @click="onSubmit">评价</el-button>
      </div>

      <el-dialog title="上传进度" :visible.sync="dialogVisible" width="900px">
        <div v-for="file in fileList" :key="file.uid">
          <h4>{{file.name}}</h4>
          <el-progress :text-inside="true" :stroke-width="26" :percentage="file.percentage"></el-progress>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import CommodityMarketingDisccussReviewEmojiInput from "./CommodityMarketingDisccussReviewEmojiInput";

export default {
  name: "CommodityMarketingDiscussReview",
  components: {
    CommodityMarketingDisccussReviewEmojiInput
  },
  props: ["targetName", "targetId", "replyId"],
  props: {
    targetName: {
      type: String
    },
    targetId: {
      type: Number
    },
    replyId: {
      type: Number
    },
    theme: {
      type: String,
      default: "normal"
    }
  },
  data() {
    return {
      dialogVisible: false,
      fileList: [],

      content: "",
      contentImages: [],
      contentVideos: [],
      contentEmojis: []
    };
  },
  methods: {
    onEmojiInput(e) {
      this.content += e;
    },
    onSubmit() {
      this.$emit("submit", {
        client: "PC端",
        targetName: this.targetName,
        targetId: this.targetId,
        replyId: this.replyId,
        content: this.content,
        contentImages: this.contentImages,
        contentVideos: this.contentVideos,
        contentEmojis: this.contentEmojis
      });

      this.reset();
    },
    reset() {
      this.content = "";
      this.contentImages = [];
      this.contentVideos = [];
      this.contentEmojis = [];
    },
    async onUploadSuccess(k, v) {
      await this.$store.dispatch("movePic", {
        packageName: "common",
        className: "resource",
        methodName: "movePic",
        params: {
          url: v.url
        }
      });

      this[k].push(this.$store.state.common.resource.movePic);
    },
    onUploadRemove(v) {},
    onUploadChange(file, fileList) {
      if (fileList.map(e => e.status == "success").reduce((p, c) => p && c)) {
        this.dialogVisible = false;
        this.$message.success("上传成功！");
      }
    },
    onUploadProgress(event, file, fileList) {
      this.dialogVisible = true;
      this.fileList = fileList;
    }
  }
};
</script>

<style lang="less" scoped>
.review {
  margin-top: 10px;
  .controls {
    .image,
    .video,
    .emoji {
      display: inline-block;
      width: 80px;
      height: 20px;
      margin: 20px 0;
      cursor: pointer;

      img {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 5px;
        vertical-align: top;
      }
      div {
        display: inline-block;
        line-height: 20px;
        text-align: center;
        vertical-align: top;
      }
    }

    .submit {
      margin: 15px 0;
      float: right;
    }
  }
}
</style>


